import { jsx as e } from "react/jsx-runtime";
import { getContrastColor as r } from "../../utils/colors.js";
function c({ rating: t = 4.7, backgroundColor: o = "#222" }) {
  const i = {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 700,
    color: r(o, !0),
    margin: 0,
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    letterSpacing: "0.00938em"
  };
  return /* @__PURE__ */ e(
    "div",
    {
      style: {
        backgroundColor: o,
        padding: 8,
        borderRadius: 8,
        width: "fit-content"
      },
      children: /* @__PURE__ */ e("p", { style: i, children: t == null ? void 0 : t.toFixed(1) })
    }
  );
}
export {
  c as CountBox
};
